import { telanganaDistrictLabel, telanganaDistrictKeyFromStored } from "../data/telanganaDistricts";
import type { Application } from "../types";
import { toDisplayCamelCase } from "./textCase";

export type PoBeneficiaryGeo = {
  displayApplicationId: string;
  district: string;
  mandal: string;
  village: string;
};

export function geoByApplicationIdFromApplications(apps: Application[]): Map<string, PoBeneficiaryGeo> {
  const map = new Map<string, PoBeneficiaryGeo>();
  for (const a of apps) {
    const key = telanganaDistrictKeyFromStored(a.district);
    const districtLabel = key ? telanganaDistrictLabel(key) : String(a.district ?? "").trim();
    map.set(a.id, {
      displayApplicationId: a.mobile.applicationId?.trim() || a.id,
      district: toDisplayCamelCase(districtLabel) || "—",
      mandal: toDisplayCamelCase(a.mandal) || "—",
      village: toDisplayCamelCase(a.village) || "—",
    });
  }
  return map;
}
